import _classCallCheck from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/eddieruiz/2024AiNomads/NomadHub/AiNomadsHub/node_modules/@babel/runtime/helpers/esm/createClass";
import { deepExtend } from "../../../../Utils/Utils";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Spin = /*#__PURE__*/function () {
  function Spin() {
    _classCallCheck(this, Spin);
    this.acceleration = 0;
    this.enable = false;
  }
  _createClass(Spin, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.acceleration !== undefined) {
        this.acceleration = setRangeValue(data.acceleration);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.position = data.position ? deepExtend({}, data.position) : undefined;
    }
  }]);
  return Spin;
}();